import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ConnectionsApi from '../api/connectionsApi';
import CapterraLogo from '../assets/images/capterra-ppc.png';
import '../css/capterra-ppc.css';
import { handleAxiosError } from '../utils/commonUtils';

const CapterraPPCAdd: React.FC = () => {
    const history = useHistory();
    const [formData, setFormData] = useState({ accountName: '', apiKey: '' });
    const [errors, setErrors] = useState({ accountName: false, apiKey: false });
    const [submitting, setSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (submitting) return;

        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value.trim() }));
        setErrors((prev) => ({ ...prev, [name]: false }));
    };

    const handleSubmit = async () => {
        const newErrors = {
            accountName: !formData.accountName.trim(),
            apiKey: !formData.apiKey.trim(),
        };
        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) return;

        setSubmitting(true);
        setErrorMessage('');

        try {
            const response = await ConnectionsApi.addConnection('capterra-ppc', formData.apiKey, formData.accountName);
            if (response.success) {
                toast.success(response.message);
                
                const queryParams = new URLSearchParams({
                    data_source: 'capterra-ppc',
                    integration: new URLSearchParams(window.location.search).get('integration') || '',
                    looker_redirect_uri: new URLSearchParams(window.location.search).get('looker_redirect_uri') || '',
                    looker_state: new URLSearchParams(window.location.search).get('looker_state') || '',
                }).toString();
                
                history.push(`/connections?${queryParams}`);
            } else {
                setErrorMessage(response.message || 'Failed to add connection.');
            }
        } catch (error: any) {
            setErrorMessage(handleAxiosError(error).message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="capterra-container">
            <div className="capterra-header">
                <img src={CapterraLogo} alt="Capterra PPC" className="capterra-logo-left" />
                <h1>Capterra PPC</h1>
            </div>
            <p>Enter a name for your account and provide your API key. You can retrieve your API key from your Capterra account manager.</p>
            <label>Account Name</label>
            <input
                type="text"
                name="accountName"
                className={errors.accountName ? 'input-error' : ''}
                value={formData.accountName}
                onChange={handleInputChange}
                disabled={submitting}
            />
            {errors.accountName && <span className="error-message">Account Name is required</span>}
            <label>API Key</label>
            <input
                type="text"
                name="apiKey"
                className={errors.apiKey ? 'input-error' : ''}
                value={formData.apiKey}
                onChange={handleInputChange}
                disabled={submitting}
            />
            {errors.apiKey && <span className="error-message">API Key is required</span>}
            {errorMessage && <div className="error-message">{errorMessage}</div>}
            <button onClick={handleSubmit} disabled={submitting}>
                {submitting ? 'Submitting...' : 'Submit'}
            </button>
        </div>
    );
};

export default CapterraPPCAdd;
